<template>
	<v-app id="inspire">

    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
			<v-list dense v-show="mostrarSeccionesEnMenúLateral">
				<v-subheader>
					SECCIONES
				</v-subheader>
        <template v-for="s in secciones">
          <!--<v-layout
            v-if="item.heading"
            :key="item.heading"
            row
            align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex
              xs6
              class="text-xs-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-flex>
          </v-layout>-->
          <v-list-item
            :key="s.id"
            @click="s.selección = !s.selección"
						v-if="s.opciones && s.opciones.length > 0"
          >
            <v-list-item-action class="mr-2">
              <v-icon class="blue--text" v-if="s.selección">check_box</v-icon>
              <v-icon v-else>check_box_outline_blank</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 font-weight-regular" :class="{'grey--text': !s.selección}">
                {{ s.nombre }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
			
			<v-divider v-if="mostrarCategoríasEnMenúLateral"></v-divider>

			<v-list dense v-show="mostrarCategoríasEnMenúLateral">
				<v-subheader>
					CATEGORÍAS
				</v-subheader>
        <template v-for="c in categorías">
          <v-list-item
            :key="c.id"
            @click="c.selección = !c.selección"
						v-show="c.visible"
          >
            <v-list-item-action class="ml-2 my-1 mr-0">
              <v-icon class="blue--text body-1" v-if="c.selección">mdi-checkbox-marked-outline</v-icon>
              <v-icon class="body-1" v-else>mdi-checkbox-blank-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="font-weight-light" :class="{'grey--text': !c.selección}">
                {{ c.nombre }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
				<v-list-item
					v-if="hayOpcionesSinCategoría && categorías && categorías.length > 0"
					@click="verOpcionesSinCategoría = !verOpcionesSinCategoría"
				>
					<v-list-item-action>
						<v-icon class="blue--text" v-if="verOpcionesSinCategoría">check_box</v-icon>
						<v-icon v-else>check_box_outline_blank</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title class="font-italic font-weight-light" :class="{'grey--text': !verOpcionesSinCategoría}">
							Sin categoría
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
      </v-list>
			
			<!--<v-divider></v-divider>-->

      <!--<v-list dense>
        <template v-for="item in items">
          <v-layout
            v-if="item.heading"
            :key="item.heading"
            row
            align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex
              xs6
              class="text-xs-center"
            >
              <a
                href="#!"
                class="body-2 black--text"
              >EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <template v-slot:activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              @click=""
            >
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ child.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item
            v-else
            :key="item.text"
            @click=""
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>-->
    </v-navigation-drawer>

    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-toolbar-title
        style="width: 300px"
        class="ml-0 pl-3"
      >
        <v-app-bar-nav-icon v-if="mostrarSeccionesEnMenúLateral || mostrarCategoríasEnMenúLateral" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">{{ $root.datos.nombre }}</span>
      </v-toolbar-title>
      <!--<v-text-field
        flat
        solo-inverted
        hide-details
        prepend-inner-icon="search"
        label="Search"
        class="hidden-sm-and-down"
      ></v-text-field>-->
      <v-spacer></v-spacer>
			<!--<v-btn icon>
        <v-icon>settings</v-icon>
      </v-btn>-->

			<v-menu offset-y left>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on">
						<v-icon>mdi-dots-vertical</v-icon>
					</v-btn>
				</template>
				<v-list>
					<!--<v-list-item
						v-for="(item, index) in items"
						:key="index"
						@click=""
					>
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item>-->
					<v-list-item @click="avisoCerrarSesión = true">
						<v-list-item-title>Cerrar sesión</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>

			<v-btn icon @click="lateralDerecho = !lateralDerecho">
        <v-icon>mdi-menu-open</v-icon>
      </v-btn>

      <!--<v-btn icon>
        <v-icon>apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
      <v-btn
        icon
        large
      >
        <v-avatar
          size="32px"
          item
        >
          <v-img
            src="https://cdn.vuetifyjs.com/images/logos/logo.svg"
            alt="Vuetify"
          >
          </v-img></v-avatar>
      </v-btn>-->
    </v-app-bar>
	
		<v-navigation-drawer
      v-model="lateralDerecho"
      app
      right
			pp-permanent
			vvvv-v-if="pedidosAgrupadosEnUbicaciones && pedidosAgrupadosEnUbicaciones.length > 0"
    >
      <v-list subheader v-for="(peu, i) in pedidosAgrupadosEnUbicaciones" :key="`peu${i}`">

				<v-subheader class="subtitle-1">{{ peu.nombre }}</v-subheader>

					<pedido-item
						v-for="(p, j) in peu.pedidos"
						:key="`p${j}`"
						:id="`pedido${i}${j}`"
						:pedido="p"
						@click.native="abrirResumenDePedido(i, j)"
						style="cursor:pointer"
					></pedido-item>
					<!-- ------------- por aquí voy, comparar comporatmientos de ambos -------------- -->
					<!--<v-list-item
						v-for="(p, j) in peu.pedidos"
						:key="`p${j}`"
						:id="`pedido${i}${j}`"
						@click="abrirResumenDePedido(i, j)"
					>
						<v-list-item-avatar>
							<v-img v-if="p.opción.imagen" :src="p.opción.imagen"></v-img>
							<v-icon v-else>mdi-pasta</v-icon>
						</v-list-item-avatar>
						<v-list-item-content>
							<v-list-item-title v-text="p.opción.nombre"></v-list-item-title>
							<v-list-item-subtitle v-if="p.notas" v-text="p.notas"></v-list-item-subtitle>
							<v-list-item-subtitle v-if="p.estado === 'NO_ORDENADO'">
								<v-chip x-small color="deep-orange" text-color="white"><v-icon x-small>mdi-alert-circle</v-icon> &nbsp; No ordenado</v-chip>
							</v-list-item-subtitle>
							<v-list-item-subtitle v-if="p.estado === 'ORDENANDO'">
								<v-chip x-small color="amber" text-color="white"><v-icon x-small>mdi-upload</v-icon> &nbsp; Ordenando...</v-chip>
							</v-list-item-subtitle>
							<v-list-item-subtitle v-if="p.estado === 'ORDENADO'">
								<v-chip x-small color="cyan darken-1" text-color="white"><v-icon x-small>mdi-clipboard-list</v-icon> &nbsp; Ordenado</v-chip>
							</v-list-item-subtitle>
							<v-list-item-subtitle v-if="p.estado === 'PREPARANDO'">
								<v-chip x-small color="teal" text-color="white"><v-icon x-small>mdi-chef-hat</v-icon> &nbsp; En preparación</v-chip>
							</v-list-item-subtitle>
							<v-list-item-subtitle v-if="p.estado === 'EN_CAMINO'">
								<v-chip x-small color="light-green darken-3" text-color="white"><v-icon x-small>mdi-walk</v-icon> &nbsp; Viene en camino</v-chip>
							</v-list-item-subtitle>
							<v-list-item-subtitle v-if="p.estado === 'SERVIDO'">
								<v-chip x-small color="green darken-2" text-color="white"><v-icon x-small>mdi-check-circle</v-icon> &nbsp; Servido</v-chip>
							</v-list-item-subtitle>
							<v-list-item-subtitle v-if="p.estado === 'PAGADO'">
								<v-chip x-small color="green darken-4" text-color="white"><v-icon x-small>mdi-check-all</v-icon> &nbsp; Finalizado</v-chip>
							</v-list-item-subtitle>
							<v-list-item-subtitle v-if="p.estado === 'CANCELADO'">
								<v-chip x-small color="grey" text-color="white"><v-icon x-small>mdi-cancel</v-icon> &nbsp; Cancelado</v-chip>
							</v-list-item-subtitle>
							<v-list-item-subtitle v-if="p.estado === 'ANULADO'">
								<v-chip x-small color="grey" text-color="white"><v-icon x-small>mdi-null</v-icon> &nbsp; Anulado</v-chip>
							</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>-->

					<div v-for="(p, j) in peu.pedidos" :key="`tp${j}`">
						<v-tooltip
							v-if="p.estado === 'NO_ORDENADO'"
							v-model="p.verMsjTem"
							:activator="`#pedido${i}${j}`"
							content-class="aviso-pedido"
							left
							light
						>
							<v-alert
								prominent
								type="error"
								style="margin: 0px"
							>
								Este pedido aún no está ordenado. Pulse para confirmarlo o hacer algún cambio.
								<v-icon>mdi-arrow-right-bold-circle</v-icon>
							</v-alert>
						</v-tooltip>
					</div>

					<v-list-item v-if="pedidosAgrupadosEnUbicaciones && pedidosAgrupadosEnUbicaciones[i].pedidos && pedidosAgrupadosEnUbicaciones[i].pedidos.length > 1" @click="abrirResumenDePedidosDeUbicación(i)">
						<v-list-item-content>
							<v-list-item-subtitle v-text="`Ver resumen de ${peu.nombre}`"></v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>

				<v-divider></v-divider>
      </v-list>


    </v-navigation-drawer>

    <v-content>
      <v-container>

				<section v-for="(s, i) in secciones" :key="s.id" v-show="!abrirPedido && s.selección">

					<v-subheader class="headline" v-if="s.opciones && s.opciones.length > 0">{{ s.nombre }}</v-subheader>

					<div class="d-flex flex-wrap justify-start" v-if="s.opciones && s.opciones.length > 0">
						<v-card
								v-for="(o, j) in s.opciones"
								:key="o.id"
								max-width="280"
								:hover="true"
								class="ma-2"
								@click="nuevoPedido(i, j)"
								v-show="o.visible"
							>
								<v-img
									v-if="o.imagen"
									height="150"
									:src="o.imagen"
								></v-img>

								<v-card-title>{{ o.nombre }}</v-card-title>

								<v-card-text>
									<p class="subtitle-1 font-weight-light">$ {{ Intl.NumberFormat('es').format(o.precios[0].precio) }}</p>

									<div>{{ o.descripción }}</div>
								</v-card-text>

								<v-divider class="mx-4"></v-divider>

								<p class="pl-4 pt-3 caption grey--text">Pulse para continuar</p>

							</v-card>
					</div>

					<v-divider v-if="i+1 < secciones.length"></v-divider>

				</section>

				<section>

					<br>

					<div v-if="abrirPedido">
						<pedido-opcion-personalizar :pedido="pedido" :ubicaciones="ubicaciones" @volver="abrirPedido = false" @agregar="agregarPedido" @modificado="abrirPedido = false; pedido = null"></pedido-opcion-personalizar>
					</div>

				</section>



      </v-container>
    </v-content>

		<v-dialog
			v-model="verResumenDePedido"
			width="500"
			persistent
		>
			<v-card>
				<pedido-resumen :pedido="pedido" :elevation="0" @modificar="modificarPedido" @cancelarPedidoNoOrdenado="cancelarPedidoNoOrdenado(pedido)"></pedido-resumen>
				<v-card-actions class="pa-5" v-if="pedido && pedido.estado === 'EN_CAMINO'">
					<v-btn tile block color="blue" class="white--text" @click="servirPedido(pedido.id)" :loading="confirmandoServido">Servido</v-btn>
				</v-card-actions>
				<v-card-actions class="pa-5">
					<v-btn tile color="blue-grey" class="white--text" @click="verResumenDePedido = false">Cerrar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog
			transition="dialog-bottom-transition"
			v-model="verResumenDePedidosDeUbicación"
			fullscreen
			persistent
		>
			<v-card>
				<v-toolbar dark color="primary">
          <v-btn icon dark @click="verResumenDePedidosDeUbicación = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="ubicación">Pedidos de {{ ubicación.nombre }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="verResumenDePedidosDeUbicación = false">Cerrar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
				<pedidos-resumen :pedidos="pedidosEnUbicación" @modificar="modificarPedido"></pedidos-resumen>
			</v-card>
		</v-dialog>

		<!-- Confirmación de cierre de sesión: -->
		<v-dialog
      v-model="avisoCerrarSesión"
      max-width="500"
    >

			<v-alert class="ma-0" prominent type="error" v-if="hayPedidosNoOrdenados">
				<v-row align="center">
					<v-col class="grow">Hay pedidos pendientes que no se han ordenado. Concrete las órdenes o cancélelas.</v-col>
					<v-col class="shrink">
						<v-btn icon @click="avisoCerrarSesión = false"><v-icon>mdi-close-circle</v-icon></v-btn>
					</v-col>
				</v-row>
			</v-alert>

			<v-alert class="ma-0" prominent type="error" v-else-if="hayPedidosModificándose">
				<v-row align="center">
					<v-col class="grow">Hay un pedido que se empezó a modificar, pero no finalizó el proceso. Concrete o cancele la modificación.</v-col>
					<v-col class="shrink">
						<v-btn icon @click="avisoCerrarSesión = false"><v-icon>mdi-close-circle</v-icon></v-btn>
					</v-col>
				</v-row>
			</v-alert>

      <v-card v-else>
        <v-card-title class="headline">Cerrar sesión</v-card-title>

        <v-card-text>

					<p>¿Está seguro de que quiere cerrar la sesión?</p>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue-grey darken-1"
            text
            @click="avisoCerrarSesión = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="orange darken-3"
            text
            @click="avisoCerrarSesión = false; $root.cerrarSesión()"
          >
            Sí, cerrar sesión
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
import PedidoOpcionPersonalizar from '../components/pedidos/Pedido_Opcion_Personalizar';
import PedidoResumen from '../components/pedidos/Pedido_Resumen';
import PedidosResumen from '../components/pedidos/Pedidos_Resumen';
import PedidoItem from '../../../cliente-comun/componentes/pedidos/Pedido_Item'
import { idAleatorio, mayúsculaInicial } from '../../../cliente-comun/utilidades'

export default {
	name: 'Inicio',
	components: {
		PedidoOpcionPersonalizar,
		PedidoResumen,
		PedidosResumen,
		PedidoItem
	},
  data: () => ({
    dialog: false,
		drawer: null,
		//
		lateralDerecho: null,
		//
		abrirPedido: false,
		secciones: [],
		categorías: [],
		opciones: [],
		ubicaciones: [],
		pedidosAgrupadosEnUbicaciones: [],
		//
		// pedido:
		verResumenDePedido: false,
		pedido: null,
		//
		// ver resumen de pedidos en una ubicación dada:
		verResumenDePedidosDeUbicación: false,
		pedidosEnUbicación: null,
		//
		// Caso especial de filtro de categorías cuando hay opciones sin categría:
		verOpcionesSinCategoría: true,
		//
		// Cantidad de categorías visibles, incluyendo "Sin categoría"
		cantidadDeCategoríasVisibles: 0,
		//
		// Confirmar cierre de sesión:
		avisoCerrarSesión: false,
		//
		//
		ubicación: null,
		//
		//
		confirmandoServido: false
	}),
	created: function() {
		this.inicializarSecciones()
		this.inicializarPedidos()
		this.inicializarOpcionesDeMenú()
		this.inicializarUbicaciones()
		this.inicializarCategorías()
	},
	computed: {
		mostrarSeccionesEnMenúLateral: function () {
			let conOpcns = 0
			for (let s of this.secciones) {
				if (s.opciones && s.opciones.length > 0) {
					conOpcns++
				}
				if (conOpcns >= 2) {
					break
				}
			}

      return conOpcns >= 2 || this.$root.modo === 'DESARROLLO'
		},
		mostrarCategoríasEnMenúLateral: function () {
      return this.cantidadDeCategoríasVisibles > 1 || (this.cantidadDeCategoríasVisibles === 1 && this.hayOpcionesSinCategoría) || this.$root.modo === 'DESARROLLO'
		},
		categoríasSeleccionadas: function () {
			let ctgrs = []
			for (let c of this.categorías) {
				let i = ctgrs.indexOf(c.id)
				if (c.selección) {
					if (i < 0) {
						ctgrs.push(c.id)
					}
				} else {
					if (i >= 0) {
						ctgrs.splice(i, 1)
					}
				}
			}

			return ctgrs
		},
		hayOpcionesSinCategoría: function () {
			for (let o of this.opciones) {
				let osc = this.opciónSinCategoría(o)
				if (osc) {
					return true
				}
			}

			return false
		},
		hayPedidosNoOrdenados: function() {
			if (!this.pedidosAgrupadosEnUbicaciones) {
				return false
			}

			// El NO_ORDENADO no debería existir aquí...
			if (this.abrirPedido && this.pedido && (this.pedido.estado === 'NO_ORDENADO'  || this.pedido.estado === 'NUEVO' || this.pedido.estado === 'ORDENANDO')) {
				return true
			}

			for (let U of this.pedidosAgrupadosEnUbicaciones) {
				if (U.pedidos) {
					for (let P of U.pedidos) {
						// El NUEVO no debería existir aquí. El ORDENANDO quizás tampoco...
						if (P.estado === 'NO_ORDENADO'  || P.estado === 'NUEVO' || P.estado === 'ORDENANDO') {
							return true
						}
					}
				}
			}

			return false
		},
		hayPedidosModificándose: function() {
			if (this.abrirPedido && this.pedido && this.pedido.estado !== 'NO_ORDENADO'  && this.pedido.estado !== 'NUEVO') {
				return true
			}

			return false
		}
	},
	watch: {
		'ubicaciones': {
			handler: function(ubccns) {
				for (let i in this.ubicaciones) {
					let tipo = mayúsculaInicial(this.ubicaciones[i].tipo)
					this.$set(this.ubicaciones[i], 'nombre', `${tipo} ${this.ubicaciones[i].identificación}`)
				}
			},
			deep: true
		},
		'categorías': {
			handler: function() {
				this.visibilidadDeCategorías()
			},
			deep: true
		},
		'opciones': {
			handler: function(opcns) {
				this.visibilidadDeOpcionesDeMenú()
				this.visibilidadDeCategorías()
			},
			deep: true
		},
		'categoríasSeleccionadas': {
			handler: function() {
				this.visibilidadDeOpcionesDeMenú()
			},
			deep: true
		},
		'verOpcionesSinCategoría': function () {
      this.visibilidadDeOpcionesDeMenú()
    },
		'pedidosEnUbicación': {
			handler: function(pdds) {
				this.verResumenDePedidosDeUbicación = this.verResumenDePedidosDeUbicación && this.pedidosEnUbicación && this.pedidosEnUbicación.length > 0
			},
			deep: true
		},
		/*'lateralDerecho': {
			handler: function(v) {
				console.log('FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFlll', v)
			}
		},*/
		'pedidosAgrupadosEnUbicaciones': {
			handler: function(v) {
				//console.log('pedidosAgrupadosEnUbicaciones----', this.pedidosAgrupadosEnUbicaciones)
				this.lateralDerecho = this.pedidosAgrupadosEnUbicaciones && this.pedidosAgrupadosEnUbicaciones.length
			},
			deep: true
		}
	},
	methods: {
		servirPedido: function(identificador) {
			this.confirmandoServido = true
			this.$root.axios.patch(`/pedidos/${identificador}`, {estado: 'SERVIDO'}).then(rta => {
				this.confirmandoServido = false
			}).catch(err => {
				this.confirmandoServido = false
				alert(err.error || 'Ocurrió un error al servir el pedido. Intente de nuevo.')
			})
		},
		nuevoPedido: function(i, j) {
			this.pedido = {
				id: idAleatorio(10),
				//opción: JSON.parse(JSON.stringify(this.opciones[i])),
				opción: JSON.parse(JSON.stringify(this.secciones[i].opciones[j])),
				ubicación: null,
				notas: '',
				estado: 'NUEVO',
			}
			this.abrirPedido = true
		},
		editarPedido: function(p) {
			this.pedido = p
			this.abrirPedido = true
		},
		agregarPedido: function(v){
			let r = this.ubicarPedidoEnUbicación(JSON.parse(JSON.stringify(this.pedido)))
			let iU = r.iU
			let iP = r.iP

			if (this.pedidosAgrupadosEnUbicaciones[iU] && this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP].estado === 'NO_ORDENADO') {
				setTimeout( () => {
					this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'verMsjTem', true)
				}, 300)
				setTimeout( () => {
					if (this.pedidosAgrupadosEnUbicaciones[iU] && this.pedidosAgrupadosEnUbicaciones[iU].pedidos && this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP]) {
						//Podría haber sido borrado antes
						this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'verMsjTem', false)
					}
				}, 15300)
			}

			this.pedido = null
			this.abrirPedido = false
		},
		modificarPedido: function(p) {
			this.verResumenDePedido = false
			this.verResumenDePedidosDeUbicación = false
			this.editarPedido(p)
		},
		abrirResumenDePedido: function(i, j) {
			this.pedido = this.pedidosAgrupadosEnUbicaciones[i].pedidos[j]
			this.verResumenDePedido = true
		},
		abrirResumenDePedidosDeUbicación: function(i) {
			this.pedidosEnUbicación = this.pedidosAgrupadosEnUbicaciones[i].pedidos
			this.ubicación = this.pedidosAgrupadosEnUbicaciones[i]
			this.verResumenDePedidosDeUbicación = true
		},
		limpiarTemporizadoresDePedido(P) {
			if (P.intervalModificar) {
				clearInterval(P.intervalModificar)
			}
			if (P.intervalCancelar) {
				clearInterval(P.intervalCancelar)
			}
		},
		crearTemporizadoresDePedido(P) {
			if (!P || !P.fecha_de_actualización || P.estado !== 'ORDENADO') {
				return
			}

			let mh = (new Date((P.fecha_de_actualización.seconds + P.tiempo_para_modificar) * 1000)).getTime() / 1000
			this.$set(P, 'puedeModificarHasta', mh)
			this.$set(P, 'intervalModificar', setInterval(() => {
				let ahora = (new Date()).getTime() / 1000
				let dif = Math.round(P.puedeModificarHasta - ahora)
				if (dif <= P.tiempo_para_modificar && dif >= 0) {
					this.$set(P, 'temporizadorModificar', dif)
				} else {
					this.$set(P, 'temporizadorModificar', 0)
					clearInterval(P.intervalModificar)
				}
			},500))

			let ch = (new Date((P.fecha_de_actualización.seconds + P.tiempo_para_cancelar) * 1000)).getTime() / 1000
			this.$set(P, 'puedeCancelarHasta', ch)
			this.$set(P, 'intervalCancelar', setInterval(() => {
				let ahora = (new Date()).getTime() / 1000
				let dif = Math.round(P.puedeCancelarHasta - ahora)
				if (dif <= P.tiempo_para_cancelar && dif >= 0) {
					this.$set(P, 'temporizadorCancelar', dif)
				} else {
					this.$set(P, 'temporizadorCancelar', 0)
					clearInterval(P.intervalCancelar)
				}
			},500))
		},
		establecerTemporizadoresDePedido(P) {
			this.limpiarTemporizadoresDePedido(P)
			this.crearTemporizadoresDePedido(P)
		},
		buscarÍndicesDePedidoEnUbicación: function(P) {
			let iU = undefined
			let iP = undefined

			for (let i in this.pedidosAgrupadosEnUbicaciones) {
				if (this.pedidosAgrupadosEnUbicaciones[i].identificación === P.ubicación.identificación && this.pedidosAgrupadosEnUbicaciones[i].tipo === P.ubicación.tipo) {
					iU = i
					break
				}
			}

			if (iU >= 0) {
				for (let i in this.pedidosAgrupadosEnUbicaciones[iU].pedidos) {
					if (this.pedidosAgrupadosEnUbicaciones[iU].pedidos[i].id === P.id) {
						iP = i
						break
					}
				}
			}

			if (iU === undefined || iP === undefined) {
				gup:
				for (let i in this.pedidosAgrupadosEnUbicaciones) {
					for (let j in this.pedidosAgrupadosEnUbicaciones[i].pedidos) {
						if (this.pedidosAgrupadosEnUbicaciones[i].pedidos[j].id === P.id) {
							iU = i
							iP = j
							break gup
						}
					}
				}
			}

			return {iU, iP}
		},
		eliminarPedidoDeUbicación: function(P) {
			let {iU, iP} = this.buscarÍndicesDePedidoEnUbicación(P)

			if (iU >= 0 && iP >= 0) {
				this.limpiarTemporizadoresDePedido(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP])
				this.pedidosAgrupadosEnUbicaciones[iU].pedidos.splice(iP, 1)
				if (!this.pedidosAgrupadosEnUbicaciones[iU].pedidos || this.pedidosAgrupadosEnUbicaciones[iU].pedidos.length == 0) {
					this.pedidosAgrupadosEnUbicaciones.splice(iU, 1)
				}
			}
		},
		ubicarPedidoEnUbicación: function(P){
			let iU = undefined
			let iP = undefined

			for (let i in this.pedidosAgrupadosEnUbicaciones) {
				if (this.pedidosAgrupadosEnUbicaciones[i].identificación === P.ubicación.identificación && this.pedidosAgrupadosEnUbicaciones[i].tipo === P.ubicación.tipo) {
					iU = i
					break
				}
			}

			if (iU === undefined) {
				let ubi = Object.assign({nombre: '', pedidos: []}, P.ubicación)
				ubi.nombre = `${mayúsculaInicial(ubi.tipo)} ${ubi.identificación}`
				this.pedidosAgrupadosEnUbicaciones.push(ubi)
				iU = this.pedidosAgrupadosEnUbicaciones.length - 1
			}

			for (let i in this.pedidosAgrupadosEnUbicaciones[iU].pedidos) {
				if (this.pedidosAgrupadosEnUbicaciones[iU].pedidos[i].id === P.id) {
					iP = i
					break
				}
			}

			if (iP === undefined) {
				//Buscar si estaba en otra ubicación, y borrarlo de ser así:
				gup:
				for (let i in this.pedidosAgrupadosEnUbicaciones) {
					if (this.pedidosAgrupadosEnUbicaciones[i].identificación !== P.ubicación.identificación || this.pedidosAgrupadosEnUbicaciones[i].tipo !== P.ubicación.tipo) {
						for (let j in this.pedidosAgrupadosEnUbicaciones[i].pedidos) {
							if (this.pedidosAgrupadosEnUbicaciones[i].pedidos[j].id === P.id) {
								this.limpiarTemporizadoresDePedido(this.pedidosAgrupadosEnUbicaciones[i].pedidos[j])
								this.pedidosAgrupadosEnUbicaciones[i].pedidos.splice(j, 1)
								break gup
							}
						}
					}
				}

				P.estado = P.estado
				P.ubicación.nombre = P.ubicación.nombre || `${mayúsculaInicial(P.ubicación.tipo)} ${P.ubicación.identificación}`
				this.pedidosAgrupadosEnUbicaciones[iU].pedidos.push(P)
				iP = this.pedidosAgrupadosEnUbicaciones[iU].pedidos.length - 1

			} else {
				this.limpiarTemporizadoresDePedido(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP])
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'versión', P.versión)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'fecha_de_creación', P.fecha_de_creación)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'fecha_de_actualización', P.fecha_de_actualización)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'estado', P.estado)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'notas', P.notas)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'modificando', P.modificando)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'temporizadorModificar', P.temporizadorModificar)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'temporizadorCancelar', P.temporizadorCancelar)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'puedeModificarHasta', P.puedeModificarHasta)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'puedeCancelarHasta', P.puedeCancelarHasta)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'tiempo_para_modificar', P.tiempo_para_modificar)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'tiempo_para_cancelar', P.tiempo_para_cancelar)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP].ubicación, 'identificación', P.ubicación.identificación)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP].ubicación, 'tipo', P.ubicación.tipo)
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP].ubicación, 'nombre', P.ubicación.nombre || `${mayúsculaInicial(P.ubicación.tipo)} ${P.ubicación.identificación}`)
				//Por alguna razón lo anterior es necesario para que coja los cambios de tiempos y notas.
				//Extráñamente la propiedad opción sí funciona y actualiza correctamente...
				this.$set(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP], 'opción', P.opción)
			}

			this.establecerTemporizadoresDePedido(this.pedidosAgrupadosEnUbicaciones[iU].pedidos[iP])

			for (let i in this.pedidosAgrupadosEnUbicaciones) {
				if (!this.pedidosAgrupadosEnUbicaciones[i].pedidos || this.pedidosAgrupadosEnUbicaciones[i].pedidos.length == 0) {
					this.pedidosAgrupadosEnUbicaciones.splice(i, 1)
					break
				}
			}

			return {iU, iP}
		},
		cancelarPedidoNoOrdenado: function(P) {
			if (P.estado === 'NO_ORDENADO') {
				this.eliminarPedidoDeUbicación(P)
				this.verResumenDePedido = false
				this.pedido = null
			} else {
				// Esto no debería ocurrir
				alert('Ocurrió un error. [4389]')
			}
		},
		inicializarPedidos: function() {
			let haceCincoHoras
			if (this.$root.modo === 'DESARROLLO') {
				haceCincoHoras = new Date((new Date()).getTime() - (600*60*60*1000))
			} else {
				haceCincoHoras = new Date((new Date()).getTime() - (5*60*60*1000))
			}
			this.$root.firestore.collection("restaurantes").doc(this.$root.datos.id).collection("pedidos").where('fecha_de_creación', '>=', haceCincoHoras).onSnapshot( snapshot => {
				snapshot.docChanges().forEach( change => {
					let obj = Object.assign({'id': change.doc.id}, change.doc.data())

					if (change.type === "added") {
						//Timeout necesario para evitar problems en caso de que la función que hizo la creación hubiera respondido después que esta y no hubiera alcanzado a cambiar el ID tras creación
						setTimeout( () => {
							this.ubicarPedidoEnUbicación(obj)
						}, 600)
					} else {
						this.ubicarPedidoEnUbicación(obj)
					}

					if (obj.estado === 'PAGADO' || obj.estado === 'CANCELADO' || obj.estado === 'ANULADO') {
						setTimeout( () => {
							this.eliminarPedidoDeUbicación(obj)
						}, 10000)
					}
				});
    	});
		},
		ubicarOpciónEnSección: function(opcn) {
			for (let i in this.secciones) {
				if (this.secciones[i].id === opcn.sección) {
					if (!this.secciones[i].opciones) {
						this.$set(this.secciones[i], 'opciones', [])
					}

					let e = this.secciones[i].opciones.some( o => o.id === opcn.id)
					if (!e) {
						this.secciones[i].opciones.push(opcn)
					} // Si sí existe no hago nada, debería actualizarse porque es una referencia

				} else {
					//Si estaba en otra sección, la quito:
					if (this.secciones[i].opciones && this.secciones[i].opciones.length > 0) {
						let ind = this.secciones[i].opciones.findIndex( o => o.id === opcn.id)
						if (ind >= 0) {
							this.secciones[i].opciones.splice(ind, 1)
						}
					}
				}
			}
		},
		opciónSinCategoría: function (o) {
			if (!o.categorías || o.categorías.length === 0) {
				return true
			} else {
				let exCa = false
				for (let c of o.categorías) {
					exCa = this.categorías.some( C => C.id === c )
					if (exCa) {
						break
					}
				}
				if (!exCa) {
					return true
				}
			}

			return false
		},
		visibilidadDeOpcionesDeMenú: function() {
			for (let i in this.opciones) {
				let vsble = true

				let osc = this.opciónSinCategoría(this.opciones[i])
				if (osc) {
					if (this.verOpcionesSinCategoría) {
						vsble = true
					} else {
						vsble = false
					}
				} else {
					vsble = false
					for (let c of this.categoríasSeleccionadas) {
						let ic = this.opciones[i].categorías.indexOf(c)
						if (ic >= 0) {
							vsble = true
							break
						}
					}
				}

				this.$set(this.opciones[i], 'visible', vsble)

				// Feo pero necesario; al parecer no funcionan bien las referencias...
				for (let s of this.secciones) {
					if (s.opciones) {
						let O = s.opciones.find( o => o.id === this.opciones[i].id)
						if (O) {
							this.$set(O, 'visible', vsble)
							break
						}
					}
				}

			}
		},
		visibilidadDeCategorías: function () {
			let ccv = 0
			for (let i in this.categorías) {
				let vsble = false
				for (let o of this.opciones) {
					let ic = o.categorías.indexOf(this.categorías[i].id)
					if (ic >= 0) {
						vsble = true
						ccv++
						break
					}
				}
				this.$set(this.categorías[i], 'visible', vsble)
			}

			this.cantidadDeCategoríasVisibles = ccv
		},
		inicializarOpcionesDeMenú: function() {
			this.$root.firestore.collection("restaurantes").doc(this.$root.datos.id).collection("opciones").onSnapshot( snapshot => {
				snapshot.docChanges().forEach( change => {
					let obj = this.$root.actualizarListadoDesdeFirestore(this.opciones, change)
					if (change.type === "added" || change.type === "modified") {
						this.ubicarOpciónEnSección(obj)
					}
        });
    	});
		},
		inicializarUbicaciones: function() { // Pendiente regla de habilitadas en reglas
			this.$root.firestore.collection("restaurantes").doc(this.$root.datos.id).collection("ubicaciones").where('habilitada', '==', true).onSnapshot( snapshot => {
				snapshot.docChanges().forEach( change => {
            this.$root.actualizarListadoDesdeFirestore(this.ubicaciones, change)
						/*setTimeout(() => {
							this.ubicaciones.sort((a, b) => {
								console.log('uuuuuuuuu', a, b)
								return a.nombre < b.nombre
							})
						}, 500)*/
				});
    	});
		},
		inicializarSecciones: function() { // Pendiente regla de habilitadas en reglas
			this.$root.firestore.collection("restaurantes").doc(this.$root.datos.id).collection("secciones").where('habilitada', '==', true).orderBy('orden').onSnapshot( snapshot => {
				snapshot.docChanges().forEach( change => {
						this.$root.actualizarListadoDesdeFirestore(this.secciones, change)
				});
				// Quizás sobre el orderBy porque hay que ordenarlas aquí en caso de que cambie despues de cargada por priemra vez..
				this.secciones.sort( (a, b) => a.orden - b.orden )

				for (let o of this.opciones) {
					this.ubicarOpciónEnSección(o)
				}
    	});
		},
		inicializarCategorías: function() { // Pendiente regla de habilitadas en reglas // Agregar orden
			this.$root.firestore.collection("restaurantes").doc(this.$root.datos.id).collection("categorias").where('habilitada', '==', true).onSnapshot( snapshot => {
				snapshot.docChanges().forEach( change => {
						this.$root.actualizarListadoDesdeFirestore(this.categorías, change)
				});
    	});
		},
	}
}
</script>

<style scoped>
.aviso-pedido {
	padding: 0px
}
</style>